import "core-js/modules/es.array.reduce.js";
import { jsx as e, Button as t, Image as n, ThemeProvider as r } from "theme-ui";
import o from "react";
import { motion as i } from "framer-motion";
import a from "query-string";
import s from "superagent";
import c from "tinycolor2";

function u() {
  return (u = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function l(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, d(e, t);
}

function d(e, t) {
  return (d = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function g(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

var f = function f(t) {
  return e(i.path, Object.assign({
    fill: "transparent",
    strokeWidth: "3",
    stroke: "hsl(0, 0%, 99%)",
    strokeLinecap: "round"
  }, t));
},
    p = function p() {
  return e("svg", {
    width: "27",
    height: "27",
    viewBox: "0 0 27 27"
  }, e(f, {
    variants: {
      closed: {
        opacity: 0,
        d: "M 7.5 14.5 L 19 14.5"
      },
      open: {
        opacity: 1,
        d: "M 7 7 L 20 20"
      }
    },
    transition: {
      duration: .2
    }
  }), e(f, {
    variants: {
      closed: {
        opacity: 0,
        d: "M 7.5 8.5 L 19 8.5"
      },
      open: {
        opacity: 1,
        d: "M 7 20 L 20 7"
      }
    },
    transition: {
      duration: .2
    }
  }), e(f, {
    d: "M22 21.6453C22 20 23 19.5 23 19.5C23 19.5 25.5 18 25.5 14V9C25.5 4 23 1.5 18 1.5H9C4 1.5 1.5 4 1.5 9V14C1.5 19 4 21 9 21H13.5C14 21 14 21 15 21.5L20.25 24.8572L20.8517 25.2118C21.5184 25.6046 22 25.631 22 24.8572V24.0287V22.7858V21.6453Z",
    variants: {
      closed: {
        opacity: 1
      },
      open: {
        opacity: 0
      }
    },
    transition: {
      duration: .2
    }
  }));
},
    h = function h() {
  return e("svg", {
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "none"
  }, e(f, {
    variants: {
      closed: {
        opacity: 0,
        d: "M 7.5 14.5 L 19 14.5"
      },
      open: {
        opacity: 1,
        d: "M 5 5 L 20 20"
      }
    },
    transition: {
      duration: .2
    }
  }), e(f, {
    variants: {
      closed: {
        opacity: 0,
        d: "M 7.5 8.5 L 19 8.5"
      },
      open: {
        opacity: 1,
        d: "M 5 20 L 20 5"
      }
    },
    transition: {
      duration: .2
    }
  }), e(i.path, {
    d: "M20.5 21.1453C20.5 19.5 21.5 19 21.5 19C21.5 19 24 18.5 24 13.5V8.5C24 3.5 21.5 1 16.5 1H7.5C2.5 1 0 3.5 0 8.5V13.5C0 18.5 2.5 20.5 7.5 20.5H12C12.5 20.5 12.5 20.5 13.5 21L18.75 24.3572L19.3517 24.7118C20.0184 25.1046 20.5 25.131 20.5 24.3572V23.5287V22.2858V21.1453Z",
    fill: "white",
    fillOpacity: "0.7",
    variants: {
      closed: {
        opacity: 1
      },
      open: {
        opacity: 0
      }
    },
    transition: {
      duration: .2
    }
  }), e(i.path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 18C21.5 18 20.5 18.5 20.5 20.1453V21.2858V22.5287V23.3572C20.5 24.131 20.0184 24.1046 19.3517 23.7118L18.75 23.3572L13.5 20C12.8174 19.6587 12.6007 19.5504 12.3729 19.516C12.267 19.5 12.1587 19.5 12 19.5H7.5C2.5 19.5 0 17.5 0 12.5V7.5C0 2.5 2.5 0 7.5 0H16.5C21.5 0 24 2.5 24 7.5V12.5C24 17.5 21.5 18 21.5 18ZM21 17.557C21.8581 17.557 24 13.557 23 13.057C22.3869 12.7505 21.8801 13.7414 21.4646 14.554C21.2023 15.0668 20.9764 15.5086 20.783 15.5086C20.283 15.5086 20 16.0554 20 16.7568C20 17.4582 20.1419 17.557 21 17.557Z",
    fill: "white",
    variants: {
      closed: {
        opacity: 1
      },
      open: {
        opacity: 0
      }
    },
    transition: {
      duration: .2
    }
  }));
},
    m = function m() {
  return e("svg", {
    width: "27",
    height: "27",
    viewBox: "0 0 27 27"
  }, e(f, {
    variants: {
      closed: {
        opacity: 0,
        d: "M 7.5 14.5 L 19 14.5"
      },
      open: {
        opacity: 1,
        d: "M 7 7 L 20 20"
      }
    },
    transition: {
      duration: .2
    }
  }), e(f, {
    variants: {
      closed: {
        opacity: 0,
        d: "M 7.5 8.5 L 19 8.5"
      },
      open: {
        opacity: 1,
        d: "M 7 20 L 20 7"
      }
    },
    transition: {
      duration: .2
    }
  }));
},
    v = function v(t) {
  var r = t.customIconUrl,
      o = t.iconVariant;
  return r ? t.isOpen ? e(m, null) : e(n, {
    src: r,
    style: {
      maxHeight: 40,
      maxWidth: 40
    }
  }) : e("filled" === o ? h : p, null);
},
    y = function y(n) {
  return e(t, {
    className: "Idengagerchat-toggleButton",
    variant: "primary",
    p: 0,
    style: n.style,
    sx: {
      variant: "styles.WidgetToggle"
    },
    disabled: n.isDisabled,
    onClick: n.toggle
  }, e(v, {
    customIconUrl: n.customIconUrl,
    iconVariant: n.iconVariant,
    isOpen: n.isOpen
  }));
};

function b() {}

var w = {
  ChatWindowContainer: {
    margin: 0,
    height: "100%",
    width: "100%",
    minHeight: 320
  },
  WidgetContainer: {
    margin: 0,
    zIndex: 2147483e3,
    position: "fixed",
    bottom: 100,
    right: 20,
    width: 376,
    maxWidth: ["90%", "376px"],
    minHeight: 250,
    maxHeight: ["60%", "704px"],
    boxShadow: "rgba(0, 0, 0, 0.16) 0px 5px 40px",
    height: "calc(100% - 120px)",
    borderRadius: 8,
    overflow: "hidden",
    notifications: {
      background: "transparent",
      margin: 0,
      zIndex: 2147483e3,
      position: "fixed",
      bottom: 80,
      right: 20,
      width: "auto",
      maxWidth: ["90%", "300px"],
      minHeight: 0,
      maxHeight: ["60%", "400px"],
      boxShadow: "none",
      height: 200,
      overflow: "hidden"
    }
  },
  WidgetToggleContainer: {
    position: "fixed",
    zIndex: 2147483003,
    bottom: "20px",
    right: "20px"
  },
  WidgetToggle: {
    outline: "none !important",
    border: "none !important",
    cursor: "pointer",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
},
    S = "__IDENGAGERCHAT__",
    C = function C(e, t) {
  void 0 === t && (t = "local");

  try {
    switch (t) {
      case "local":
        return function (e) {
          try {
            var t = e && e.localStorage;
            return u({}, t, {
              get: function get(e) {
                var n = t.getItem("" + S + e);
                if (!n) return null;

                try {
                  return JSON.parse(n);
                } catch (e) {
                  return n;
                }
              },
              set: function set(e, n) {
                t.setItem("" + S + e, JSON.stringify(n));
              },
              remove: function remove(e) {
                t.removeItem(e);
              }
            });
          } catch (e) {
            return {
              _db: {},
              getItem: function getItem(e) {
                return this._db[e] || null;
              },
              setItem: function setItem(e, t) {
                this._db[e] = t;
              },
              removeItem: function removeItem(e) {
                delete this._db[e];
              },
              get: function get(e) {
                return this._db[e] || null;
              },
              set: function set(e, t) {
                this._db[e] = t;
              },
              remove: function remove(e) {
                delete this._db[e];
              }
            };
          }
        }(e);

      case "session":
        return function (e) {
          try {
            var t = e && e.sessionStorage;
            return u({}, t, {
              get: function get(e) {
                var n = t.getItem("" + S + e);
                if (!n) return null;

                try {
                  return JSON.parse(n);
                } catch (e) {
                  return n;
                }
              },
              set: function set(e, n) {
                t.setItem("" + S + e, JSON.stringify(n));
              },
              remove: function remove(e) {
                t.removeItem(e);
              }
            });
          } catch (e) {
            return {
              _db: {},
              getItem: function getItem(e) {
                return this._db[e] || null;
              },
              setItem: function setItem(e, t) {
                this._db[e] = t;
              },
              removeItem: function removeItem(e) {
                delete this._db[e];
              },
              get: function get(e) {
                return this._db[e] || null;
              },
              set: function set(e, t) {
                this._db[e] = t;
              },
              remove: function remove(e) {
                delete this._db[e];
              }
            };
          }
        }(e);

      case "cookie":
        return function () {
          try {
            throw new Error("Cookie storage has not been implemented!");
          } catch (e) {
            return {
              _db: {},
              getItem: function getItem(e) {
                return this._db[e] || null;
              },
              setItem: function setItem(e, t) {
                this._db[e] = t;
              },
              removeItem: function removeItem(e) {
                delete this._db[e];
              },
              get: function get(e) {
                return this._db[e] || null;
              },
              set: function set(e, t) {
                this._db[e] = t;
              },
              remove: function remove(e) {
                delete this._db[e];
              }
            };
          }
        }();

      case "memory":
      default:
        return {
          _db: {},
          getItem: function getItem(e) {
            return this._db[e] || null;
          },
          setItem: function setItem(e, t) {
            this._db[e] = t;
          },
          removeItem: function removeItem(e) {
            delete this._db[e];
          },
          get: function get(e) {
            return this._db[e] || null;
          },
          set: function set(e, t) {
            this._db[e] = t;
          },
          remove: function remove(e) {
            delete this._db[e];
          }
        };
    }
  } catch (e) {
    return {
      _db: {},
      getItem: function getItem(e) {
        return this._db[e] || null;
      },
      setItem: function setItem(e, t) {
        this._db[e] = t;
      },
      removeItem: function removeItem(e) {
        delete this._db[e];
      },
      get: function get(e) {
        return this._db[e] || null;
      },
      set: function set(e, t) {
        this._db[e] = t;
      },
      remove: function remove(e) {
        delete this._db[e];
      }
    };
  }
},
    I = function () {
  function e(e) {
    this.debugModeEnabled = !!e;
  }

  var t = e.prototype;
  return t.debug = function () {
    var e;
    this.debugModeEnabled && (e = console).debug.apply(e, [].slice.call(arguments));
  }, t.log = function () {
    var e;
    this.debugModeEnabled && (e = console).log.apply(e, [].slice.call(arguments));
  }, t.info = function () {
    var e;
    (e = console).info.apply(e, [].slice.call(arguments));
  }, t.warn = function () {
    var e;
    (e = console).warn.apply(e, [].slice.call(arguments));
  }, t.error = function () {
    var e;
    (e = console).error.apply(e, [].slice.call(arguments));
  }, e;
}();

function x(e) {
  var t = function (e) {
    var t = Array.prototype,
        n = Function.prototype,
        r = Object.prototype,
        o = r.toString,
        i = r.hasOwnProperty,
        a = e.navigator,
        s = n.bind,
        c = t.forEach,
        u = Array.isArray,
        l = t.slice,
        d = {},
        g = u || function (e) {
      return "[object Array]" === o.call(e);
    };

    function f(e) {
      try {
        return /^\s*\bfunction\b/.test(e);
      } catch (e) {
        return !1;
      }
    }

    function p(e) {
      return "[object String]" == o.call(e);
    }

    function h(e) {
      return void 0 === e;
    }

    function m(e, t, n) {
      if (null != e) if (c && e.forEach === c) e.forEach(t, n);else if (e.length === +e.length) {
        for (var r = 0, o = e.length; r < o; r++) {
          if (r in e && t.call(n, e[r], r, e) === d) return;
        }
      } else for (var a in e) {
        if (i.call(e, a) && t.call(n, e[a], a, e) === d) return;
      }
    }

    var v,
        y,
        b,
        w,
        S,
        C,
        I,
        x,
        O,
        _,
        E,
        M,
        T = (S = {
      '"': '"',
      "\\": "\\",
      "/": "/",
      b: "\b",
      f: "\f",
      n: "\n",
      r: "\r",
      t: "\t"
    }, C = function C(e) {
      var t = new SyntaxError(e);
      throw t.at = v, t.text = b, t;
    }, I = function I(e) {
      return e && e !== y && C("Expected '" + e + "' instead of '" + y + "'"), y = b.charAt(v), v += 1, y;
    }, x = function x() {
      var e,
          t = "";

      for ("-" === y && (t = "-", I("-")); y >= "0" && y <= "9";) {
        t += y, I();
      }

      if ("." === y) for (t += "."; I() && y >= "0" && y <= "9";) {
        t += y;
      }
      if ("e" === y || "E" === y) for (t += y, I(), "-" !== y && "+" !== y || (t += y, I()); y >= "0" && y <= "9";) {
        t += y, I();
      }
      if (e = +t, isFinite(e)) return e;
      C("Bad number");
    }, O = function O() {
      var e,
          t,
          n,
          r = "";
      if ('"' === y) for (; I();) {
        if ('"' === y) return I(), r;
        if ("\\" === y) {
          if (I(), "u" === y) {
            for (n = 0, t = 0; t < 4 && (e = parseInt(I(), 16), isFinite(e)); t += 1) {
              n = 16 * n + e;
            }

            r += String.fromCharCode(n);
          } else {
            if ("string" != typeof S[y]) break;
            r += S[y];
          }
        } else r += y;
      }
      C("Bad string");
    }, _ = function _() {
      for (; y && y <= " ";) {
        I();
      }
    }, E = function E() {
      var e = [];

      if ("[" === y) {
        if (I("["), _(), "]" === y) return I("]"), e;

        for (; y;) {
          if (e.push(w()), _(), "]" === y) return I("]"), e;
          I(","), _();
        }
      }

      C("Bad array");
    }, M = function M() {
      var e,
          t = {};

      if ("{" === y) {
        if (I("{"), _(), "}" === y) return I("}"), t;

        for (; y;) {
          if (e = O(), _(), I(":"), Object.hasOwnProperty.call(t, e) && C('Duplicate key "' + e + '"'), t[e] = w(), _(), "}" === y) return I("}"), t;
          I(","), _();
        }
      }

      C("Bad object");
    }, w = function w() {
      switch (_(), y) {
        case "{":
          return M();

        case "[":
          return E();

        case '"':
          return O();

        case "-":
          return x();

        default:
          return y >= "0" && y <= "9" ? x() : function () {
            switch (y) {
              case "t":
                return I("t"), I("r"), I("u"), I("e"), !0;

              case "f":
                return I("f"), I("a"), I("l"), I("s"), I("e"), !1;

              case "n":
                return I("n"), I("u"), I("l"), I("l"), null;
            }

            C('Unexpected "' + y + '"');
          }();
      }
    }, function (e) {
      var t;
      return b = e, v = 0, y = " ", t = w(), _(), y && C("Syntax error"), t;
    });

    function P(e) {
      var t,
          n,
          r,
          o,
          i = "";

      for (t = n = 0, r = (e = (e + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, o = 0; o < r; o++) {
        var a = e.charCodeAt(o),
            s = null;
        a < 128 ? n++ : s = a > 127 && a < 2048 ? String.fromCharCode(a >> 6 | 192, 63 & a | 128) : String.fromCharCode(a >> 12 | 224, a >> 6 & 63 | 128, 63 & a | 128), null !== s && (n > t && (i += e.substring(t, n)), i += s, t = n = o + 1);
      }

      return n > t && (i += e.substring(t, e.length)), i;
    }

    return {
      ArrayProto: t,
      FuncProto: n,
      ObjProto: r,
      toString: o,
      hasOwnProperty: i,
      win: e,
      windowConsole: e.console,
      navigator: a,
      document: e.document,
      windowOpera: e.opera,
      screen: e.screen,
      userAgent: a.userAgent,
      intl: e.Intl,
      nativeBind: s,
      nativeForEach: c,
      nativeIndexOf: t.indexOf,
      nativeIsArray: u,
      slice: l,
      breaker: d,
      __NOOP: function __NOOP() {},
      __NOOPTIONS: {},
      isFunction: f,
      isString: p,
      includes: function includes(e, t) {
        return -1 !== e.indexOf(t);
      },
      isUndefined: h,
      timestamp: function timestamp() {
        return Date.now = Date.now || function () {
          return +new Date();
        }, Date.now();
      },
      each: m,
      trim: function trim(e) {
        return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      },
      extend: function extend(e) {
        return m([].slice.call(arguments, 1), function (t) {
          for (var n in t) {
            void 0 !== t[n] && (e[n] = t[n]);
          }
        }), e;
      },
      bind: function bind(e, t) {
        var n, _r;

        if (s && e.bind === s) return s.apply(e, l.call(arguments, 1));
        if (!f(e)) throw new TypeError();
        return n = l.call(arguments, 2), _r = function r() {
          if (!(this instanceof _r)) return e.apply(t, n.concat(l.call(arguments)));
          var o = {};
          o.prototype = e.prototype;
          var i = new o();
          o.prototype = null;
          var a = e.apply(i, n.concat(l.call(arguments)));
          return Object(a) === a ? a : i;
        };
      },
      truncate: function e(t, n) {
        var r;
        return "string" == typeof t ? r = t.slice(0, n) : g(t) ? (r = [], m(t, function (t) {
          r.push(e(t, n));
        })) : function (e) {
          return e === Object(e) && !g(e);
        }(t) ? (r = {}, m(t, function (t, o) {
          r[o] = e(t, n);
        })) : r = t, r;
      },
      stripEmptyProperties: function stripEmptyProperties(e) {
        var t = {};
        return m(e, function (e, n) {
          p(e) && e.length > 0 && (t[n] = e);
        }), t;
      },
      HTTPBuildQuery: function HTTPBuildQuery(e, t) {
        var n,
            r,
            o = [];
        return h(t) && (t = "&"), m(e, function (e, t) {
          n = encodeURIComponent(e.toString()), r = encodeURIComponent(t), o[o.length] = r + "=" + n;
        }), o.join(t);
      },
      JSONEncode: function JSONEncode(e) {
        var t = function t(e) {
          var t = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
              n = {
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            '"': '\\"',
            "\\": "\\\\"
          };
          return t.lastIndex = 0, t.test(e) ? '"' + e.replace(t, function (e) {
            var t = n[e];
            return "string" == typeof t ? t : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
          }) + '"' : '"' + e + '"';
        };

        return function e(n, r) {
          var a = "",
              s = 0,
              c = "",
              u = "",
              l = 0,
              d = a,
              g = [],
              f = r[n];

          switch (f && "object" == typeof f && "function" == typeof f.toJSON && (f = f.toJSON(n)), typeof f) {
            case "string":
              return t(f);

            case "number":
              return isFinite(f) ? String(f) : "null";

            case "boolean":
            case "undefined":
              return String(f);

            case "object":
              if (!f) return "null";

              if (a += "    ", g = [], "[object Array]" === o.apply(f)) {
                for (l = f.length, s = 0; s < l; s += 1) {
                  g[s] = e(s, f) || "null";
                }

                return u = 0 === g.length ? "[]" : a ? "[\n" + a + g.join(",\n" + a) + "\n" + d + "]" : "[" + g.join(",") + "]", a = d, u;
              }

              for (c in f) {
                i.call(f, c) && (u = e(c, f)) && g.push(t(c) + (a ? ": " : ":") + u);
              }

              return u = 0 === g.length ? "{}" : a ? "{" + g.join(",") + d + "}" : "{" + g.join(",") + "}", a = d, u;
          }
        }("", {
          "": e
        });
      },
      JSONDecode: T,
      utf8Encode: P,
      base64Encode: function base64Encode(e) {
        var t,
            n,
            r,
            o,
            i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            a = 0,
            s = 0,
            c = "",
            u = [];
        if (!e) return e;
        e = P(e);

        do {
          t = (o = e.charCodeAt(a++) << 16 | e.charCodeAt(a++) << 8 | e.charCodeAt(a++)) >> 12 & 63, n = o >> 6 & 63, r = 63 & o, u[s++] = i.charAt(o >> 18 & 63) + i.charAt(t) + i.charAt(n) + i.charAt(r);
        } while (a < e.length);

        switch (c = u.join(""), e.length % 3) {
          case 1:
            c = c.slice(0, -2) + "==";
            break;

          case 2:
            c = c.slice(0, -1) + "=";
        }

        return c;
      },
      getQueryParam: function getQueryParam(e, t) {
        t = t.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
        var n = new RegExp("[\\?&]" + t + "=([^&#]*)").exec(e);
        if (null === n || n && "string" != typeof n[1] && n[1].length) return "";
        var r = n[1];

        try {
          r = decodeURIComponent(r);
        } catch (e) {
          console.error("Skipping decoding for malformed query param: " + r);
        }

        return r.replace(/\+/g, " ");
      }
    };
  }(e),
      n = t.navigator,
      r = t.userAgent,
      o = t.windowOpera,
      i = t.intl,
      a = t.each,
      s = t.extend,
      c = t.includes,
      u = t.timestamp,
      l = t.stripEmptyProperties,
      d = t.getQueryParam,
      g = {
    campaignParams: function campaignParams() {
      var e = "utm_source utm_medium utm_campaign utm_content utm_term".split(" "),
          t = "",
          n = {};
      return a(e, function (e) {
        (t = d(document.URL, e)).length && (n[e] = t);
      }), n;
    },
    searchEngine: function searchEngine(e) {
      return 0 === e.search("https?://(.*)google.([^/?]*)") ? "google" : 0 === e.search("https?://(.*)bing.com") ? "bing" : 0 === e.search("https?://(.*)yahoo.com") ? "yahoo" : 0 === e.search("https?://(.*)duckduckgo.com") ? "duckduckgo" : null;
    },
    searchInfo: function searchInfo(e) {
      var t = g.searchEngine(e),
          n = "yahoo" != t ? "q" : "p",
          r = {};

      if (null !== t) {
        r.$search_engine = t;
        var o = d(e, n);
        o.length && (r.ph_keyword = o);
      }

      return r;
    },
    browser: function browser(e, t, n) {
      return t = t || "", n || c(e, " OPR/") ? c(e, "Mini") ? "Opera Mini" : "Opera" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : c(e, "IEMobile") || c(e, "WPDesktop") ? "Internet Explorer Mobile" : c(e, "SamsungBrowser/") ? "Samsung Internet" : c(e, "Edge") || c(e, "Edg/") ? "Microsoft Edge" : c(e, "FBIOS") ? "Facebook Mobile" : c(e, "Chrome") ? "Chrome" : c(e, "CriOS") ? "Chrome iOS" : c(e, "UCWEB") || c(e, "UCBrowser") ? "UC Browser" : c(e, "FxiOS") ? "Firefox iOS" : c(t, "Apple") ? c(e, "Mobile") ? "Mobile Safari" : "Safari" : c(e, "Android") ? "Android Mobile" : c(e, "Konqueror") ? "Konqueror" : c(e, "Firefox") ? "Firefox" : c(e, "MSIE") || c(e, "Trident/") ? "Internet Explorer" : c(e, "Gecko") ? "Mozilla" : "";
    },
    browserVersion: function browserVersion(e, t, n) {
      var r = {
        "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
        "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
        Chrome: /Chrome\/(\d+(\.\d+)?)/,
        "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
        "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
        Safari: /Version\/(\d+(\.\d+)?)/,
        "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
        Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
        Firefox: /Firefox\/(\d+(\.\d+)?)/,
        "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
        Konqueror: /Konqueror:(\d+(\.\d+)?)/,
        BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
        "Android Mobile": /android\s(\d+(\.\d+)?)/,
        "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
        "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
        Mozilla: /rv:(\d+(\.\d+)?)/
      }[g.browser(e, t, n)];
      if (void 0 === r) return null;
      var o = e.match(r);
      return o ? parseFloat(o[o.length - 2]) : null;
    },
    os: function os() {
      var e = r;
      return /Windows/i.test(e) ? /Phone/.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : "Windows" : /(iPhone|iPad|iPod)/.test(e) ? "iOS" : /Android/.test(e) ? "Android" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Mac/i.test(e) ? "Mac OS X" : /Linux/.test(e) ? "Linux" : /CrOS/.test(e) ? "Chrome OS" : "";
    },
    device: function device(e) {
      return /Windows Phone/i.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : /iPad/.test(e) ? "iPad" : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Android/.test(e) ? "Android" : "";
    },
    referringDomain: function referringDomain(e) {
      var t = e.split("/");
      return t.length >= 3 ? t[2] : "";
    },
    timezone: function timezone(e) {
      try {
        return e.DateTimeFormat().resolvedOptions().timeZone;
      } catch (e) {
        return null;
      }
    },
    properties: function properties() {
      var t;
      return s(l({
        os: g.os(),
        browser: g.browser(r, n.vendor, o),
        referrer: document.referrer,
        referring_domain: g.referringDomain(document.referrer),
        device: g.device(r),
        time_zone: g.timezone(i)
      }), {
        current_url: e.location.href,
        host: e.location.host,
        pathname: e.location.pathname,
        browser_version: null == (t = g.browserVersion(r, n.vendor, o)) ? void 0 : t.toString(),
        screen_height: screen.height,
        screen_width: screen.width,
        lib: "web",
        insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
        time: u() / 1e3
      });
    }
  };

  return g.properties();
}

var O = function O(e, t) {
  var n = function n(e) {
    t(e);
  };

  return e.addEventListener ? (e.addEventListener("message", n), function () {
    return e.removeEventListener("message", n);
  }) : (e.attachEvent("onmessage", n), function () {
    return e.detachEvent("onmessage", n);
  });
},
    _ = function _(e, t, n) {
  if (e.addEventListener) {
    for (var r, o = function (e, t) {
      var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (n) return (n = n.call(e)).next.bind(n);

      if (Array.isArray(e) || (n = function (e, t) {
        if (e) {
          if ("string" == typeof e) return g(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? g(e, t) : void 0;
        }
      }(e))) {
        n && (e = n);
        var r = 0;
        return function () {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }(t); !(r = o()).done;) {
      e.addEventListener(r.value, n);
    }

    return function () {
      return t.map(function (t) {
        return e.removeEventListener(t, n);
      });
    };
  }

  return console.error("Custom events are not supported in your browser!"), b;
},
    E = function (t) {
  function n(e) {
    var n, r;
    if ((n = t.call(this, e) || this).subscriptions = [], n.EVENTS = ["idengagerchat:open", "idengagerchat:close", "idengagerchat:toggle", "idengagerchat:identify", "storytime:customer:set"], n.getDefaultTitle = function (e) {
      try {
        var t = n.props,
            r = t.title,
            o = t.setDefaultTitle;
        return Promise.resolve(o && "function" == typeof o ? o(e) : r || e.title);
      } catch (e) {
        return Promise.reject(e);
      }
    }, n.getDefaultSubtitle = function (e) {
      try {
        var t = n.props,
            r = t.subtitle,
            o = t.setDefaultSubtitle;
        return Promise.resolve(o && "function" == typeof o ? o(e) : r || e.subtitle);
      } catch (e) {
        return Promise.reject(e);
      }
    }, n.getDefaultGreeting = function (e) {
      try {
        var t = n.props,
            r = t.greeting,
            o = t.setDefaultGreeting;
        return Promise.resolve(o && "function" == typeof o ? o(e) : r || e.greeting);
      } catch (e) {
        return Promise.reject(e);
      }
    }, n.setIframeRef = function (e) {
      n.iframeRef = e;
    }, n.getIframeUrl = function () {
      return n.props.iframeUrlOverride || "https://chat-widget.idengager.com";
    }, n.handleConfigUpdated = function (e) {
      n.setState({
        config: u({}, n.state.config, e)
      }), n.send("config:update", e);
    }, n.handleCustomerIdUpdated = function (e) {
      var t = n.storage.getCustomerId(),
          r = e || t,
          o = u({}, n.state.config, {
        customerId: r
      });
      n.setState({
        config: o,
        query: a.stringify(o, {
          skipEmptyString: !0,
          skipNull: !0
        })
      }), n.logger.debug("Updated customer ID:", r);
    }, n.fetchWidgetSettings = function () {
      try {
        var e = n.props,
            t = {};
        return Promise.resolve(function (e, t) {
          void 0 === t && (t = "https://chat.idengager.com");

          try {
            return Promise.resolve(s.get(t + "/api/widget_settings").query({
              account_id: e
            }).then(function (e) {
              return e.body.data;
            }));
          } catch (e) {
            return Promise.reject(e);
          }
        }(e.accountId, e.baseUrl).then(function (e) {
          return e || t;
        }).catch(function () {
          return t;
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    }, n.updateWidgetSettingsMetadata = function () {
      var e = n.props,
          t = e.baseUrl;
      return function (e, t, n) {
        void 0 === n && (n = "https://chat.idengager.com");

        try {
          return Promise.resolve(s.put(n + "/api/widget_settings/metadata").send({
            account_id: e,
            metadata: t
          }).then(function (e) {
            return e.body.data;
          }));
        } catch (e) {
          return Promise.reject(e);
        }
      }(e.accountId, x(window), t).catch(function (e) {
        n.logger.error("Failed to update widget metadata:", e);
      });
    }, n.customEventHandlers = function (e) {
      if (!e || !e.type) return null;
      var t = e.detail;

      switch (e.type) {
        case "idengagerchat:open":
          return n.handleOpenWidget();

        case "idengagerchat:close":
          return n.handleCloseWidget();

        case "idengagerchat:toggle":
          return n.handleToggleOpen();

        case "storytime:customer:set":
          return n.handleCustomerIdUpdated(t);

        default:
          return null;
      }
    }, n.postMessageHandlers = function (e) {
      n.logger.debug("Handling in parent:", e.data);
      var t = n.getIframeUrl(),
          r = new URL(t);
      if (e.origin !== r.origin) return null;
      var o = e.data,
          i = o.payload,
          a = void 0 === i ? {} : i;

      switch (o.event) {
        case "chat:loaded":
          return n.handleChatLoaded();

        case "customer:created":
        case "customer:updated":
          return n.handleCacheCustomerId(a);

        case "conversation:join":
          return n.sendCustomerUpdate(a);

        case "message:received":
          return n.handleMessageReceived(a);

        case "message:sent":
          return n.handleMessageSent(a);

        case "messages:unseen":
          return n.handleUnseenMessages(a);

        case "messages:seen":
          return n.handleMessagesSeen();

        case "idengagerchat:open":
        case "idengagerchat:close":
          return n.handleToggleOpen();

        default:
          return null;
      }
    }, n.send = function (e, t) {
      n.logger.debug("Sending from parent:", {
        event: e,
        payload: t
      });
      var r = n.iframeRef;
      if (!r) throw new Error("Attempted to send event " + e + " with payload " + JSON.stringify(t) + " before iframeRef was ready");
      r.contentWindow.postMessage({
        event: e,
        payload: t
      }, n.getIframeUrl());
    }, n.handleMessageReceived = function (e) {
      var t = n.props.onMessageReceived,
          r = void 0 === t ? b : t;
      e.user_id && !e.customer_id && r && r(e);
    }, n.handleMessageSent = function (e) {
      var t = n.props.onMessageSent,
          r = void 0 === t ? b : t;
      r && r(e);
    }, n.handleUnseenMessages = function (e) {
      n.logger.debug("Handling unseen messages:", e), n.setState({
        shouldDisplayNotifications: !0
      }), n.send("notifications:display", {
        shouldDisplayNotifications: !0
      });
    }, n.handleMessagesSeen = function () {
      n.logger.debug("Handling messages seen"), n.setState({
        shouldDisplayNotifications: !1
      }), n.storage.setPopupSeen(!0), n.send("notifications:display", {
        shouldDisplayNotifications: !1
      });
    }, n.shouldOpenByDefault = function () {
      var e = n.props,
          t = e.defaultIsOpen,
          r = e.isOpenByDefault,
          o = e.persistOpenState;
      if (!e.canToggle) return !0;
      var i = n.storage.getOpenState();
      return o ? i : !(!r && !t);
    }, n.handleChatLoaded = function () {
      n.setState({
        isLoaded: !0
      });
      var e = n.state.config,
          t = (void 0 === e ? {} : e).subscriptionPlan,
          r = void 0 === t ? null : t,
          o = n.props,
          i = o.popUpInitialMessage,
          a = o.onChatLoaded,
          s = void 0 === a ? b : a;
      s && "function" == typeof s && s(), n.shouldOpenByDefault() && n.setState({
        isOpen: !0
      }, function () {
        return n.emitToggleEvent(!0);
      }), i && !n.storage.getPopupSeen() && setTimeout(function () {
        n.setState({
          shouldDisplayNotifications: !0
        }), n.send("notifications:display", {
          shouldDisplayNotifications: !0,
          popUpInitialMessage: !0
        });
      }, "number" == typeof i ? i : 0), n.send("idengagerchat:plan", {
        plan: r
      });
    }, n.formatCustomerMetadata = function () {
      var e = n.props.customer,
          t = void 0 === e ? {} : e;
      return t ? Object.keys(t).reduce(function (e, n) {
        var r, o;
        return u({}, e, "metadata" === n ? ((r = {})[n] = t[n], r) : ((o = {})[n] = String(t[n]), o));
      }, {}) : {};
    }, n.sendCustomerUpdate = function (e) {
      var t = e.customerId,
          r = u({}, x(window), n.formatCustomerMetadata());
      return n.send("customer:update", {
        customerId: t,
        metadata: r
      });
    }, n.handleCacheCustomerId = function (e) {
      var t = e.customerId;
      n.logger.debug("Caching customer ID:", t), window.dispatchEvent(new CustomEvent("idengagerchat:customer:set", {
        detail: t
      })), n.storage.setCustomerId(t);
    }, n.emitToggleEvent = function (e) {
      n.send("idengagerchat:toggle", {
        isOpen: e
      });
      var t = n.props,
          r = t.persistOpenState,
          o = t.onChatOpened,
          i = void 0 === o ? b : o,
          a = t.onChatClosed,
          s = void 0 === a ? b : a;
      void 0 !== r && r && n.storage.setOpenState(e), e ? i && i() : s && s();
    }, n.handleOpenWidget = function () {
      n.props.canToggle && !n.state.isOpen && (n.state.shouldDisplayNotifications ? n.setState({
        isTransitioning: !0
      }, function () {
        setTimeout(function () {
          n.setState({
            isOpen: !0,
            isTransitioning: !1
          }, function () {
            return n.emitToggleEvent(!0);
          });
        }, 200);
      }) : n.setState({
        isOpen: !0
      }, function () {
        return n.emitToggleEvent(!0);
      }));
    }, n.handleCloseWidget = function () {
      n.props.canToggle && n.state.isOpen && n.setState({
        isOpen: !1
      }, function () {
        return n.emitToggleEvent(!1);
      });
    }, n.handleToggleOpen = function () {
      var e = n.state,
          t = e.isOpen,
          r = !t;
      e.isLoaded && n.props.canToggle && (!t && e.shouldDisplayNotifications ? n.setState({
        isTransitioning: !0
      }, function () {
        setTimeout(function () {
          n.setState({
            isOpen: r,
            isTransitioning: !1
          }, function () {
            return n.emitToggleEvent(r);
          });
        }, 200);
      }) : n.setState({
        isOpen: r
      }, function () {
        return n.emitToggleEvent(r);
      }));
    }, !e.accountId) throw new Error("An `accountId` is required to run the Idengagerchat chat!");
    if (!((r = e.accountId) && "string" == typeof r && r.length && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(r))) throw console.error("The `accountId` must be a valid UUID. (Received invalid `accountId`: " + e.accountId + ")"), console.error("If you're missing a Idengagerchat `accountId`, you can get one by signing up for a free account at https://app.idengagerchat.io/register"), new Error("Invalid `accountId`: " + e.accountId);
    return n.state = {
      isOpen: !1,
      isLoaded: !1,
      query: "",
      config: {},
      shouldDisplayNotifications: !1,
      isTransitioning: !1
    }, n;
  }

  l(n, t);
  var o = n.prototype;
  return o.componentDidMount = function () {
    try {
      var e = this;
      return Promise.resolve(e.fetchWidgetSettings()).then(function (t) {
        var n,
            r = e.props,
            o = r.accountId,
            i = r.primaryColor,
            s = r.baseUrl,
            c = r.awayMessage,
            l = r.newMessagePlaceholder,
            d = r.emailInputPlaceholder,
            g = r.newMessagesNotificationText,
            f = r.agentAvailableText,
            p = r.agentUnavailableText,
            h = r.showAgentAvailability,
            m = r.requireEmailUpfront,
            v = r.canToggle,
            y = r.customer,
            b = void 0 === y ? {} : y,
            w = (n = window, Boolean("localhost" === n.location.hostname || "[::1]" === n.location.hostname || n.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)));
        e.logger = new I(w), e.subscriptions = [O(window, e.postMessageHandlers), _(window, e.EVENTS, e.customEventHandlers)], e.storage = function (e, t) {
          void 0 === t && (t = {});
          var n = t.defaultType,
              r = t.openStateType,
              o = void 0 === r ? "session" : r,
              i = C(e, void 0 === n ? "local" : n),
              a = C(e, o);
          return {
            getCustomerId: function getCustomerId() {
              return i.get("__CUSTOMER_ID__");
            },
            setCustomerId: function setCustomerId(e) {
              return i.set("__CUSTOMER_ID__", e);
            },
            removeCustomerId: function removeCustomerId() {
              return i.remove("__CUSTOMER_ID__");
            },
            getOpenState: function getOpenState() {
              return a.get(":open");
            },
            setOpenState: function setOpenState(e) {
              return a.set(":open", e);
            },
            clearOpenState: function clearOpenState() {
              return a.remove(":open");
            },
            getPopupSeen: function getPopupSeen() {
              return a.get(":pop_up_seen");
            },
            setPopupSeen: function setPopupSeen(e) {
              return a.set(":pop_up_seen", e);
            },
            clearPopupSeen: function clearPopupSeen() {
              return a.remove(":pop_up_seen");
            }
          };
        }(window);
        var S = u({}, x(window), b);
        return Promise.resolve(e.getDefaultTitle(t)).then(function (n) {
          return Promise.resolve(e.getDefaultSubtitle(t)).then(function (r) {
            var u = i || t.color;
            return Promise.resolve(e.getDefaultGreeting(t)).then(function (i) {
              var y,
                  b,
                  w,
                  C = {
                accountId: o,
                baseUrl: s,
                title: n,
                subtitle: r,
                primaryColor: u,
                greeting: i,
                awayMessage: c || t.away_message,
                newMessagePlaceholder: l || t.new_message_placeholder,
                emailInputPlaceholder: d || t.email_input_placeholder,
                newMessagesNotificationText: g || t.new_messages_notification_text,
                companyName: null == t || null == (y = t.account) ? void 0 : y.company_name,
                requireEmailUpfront: m || t.require_email_upfront ? 1 : 0,
                showAgentAvailability: h || t.show_agent_availability ? 1 : 0,
                agentAvailableText: t.agent_available_text || f,
                agentUnavailableText: t.agent_unavailable_text || p,
                closeable: v ? 1 : 0,
                customerId: e.storage.getCustomerId(),
                subscriptionPlan: null == t || null == (b = t.account) ? void 0 : b.subscription_plan,
                isOutsideWorkingHours: null == t || null == (w = t.account) ? void 0 : w.is_outside_working_hours,
                isBrandingHidden: null == t ? void 0 : t.is_branding_hidden,
                metadata: JSON.stringify(S),
                version: "1.1.8"
              },
                  I = a.stringify(C, {
                skipEmptyString: !0,
                skipNull: !0
              });
              return console.log("query" + JSON.stringify(I)), e.setState({
                config: C,
                query: I
              }), Promise.resolve(e.updateWidgetSettingsMetadata()).then(function () {});
            });
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, o.componentWillUnmount = function () {
    this.subscriptions.forEach(function (e) {
      "function" == typeof e && e();
    });
  }, o.componentDidUpdate = function (e) {
    var t = this.props,
        n = t.accountId,
        r = t.title,
        o = t.subtitle,
        i = t.primaryColor,
        a = t.baseUrl,
        s = t.greeting,
        c = t.newMessagePlaceholder,
        u = t.emailInputPlaceholder,
        l = t.newMessagesNotificationText,
        d = t.requireEmailUpfront,
        g = t.showAgentAvailability,
        f = t.agentAvailableText,
        p = t.agentUnavailableText,
        h = [e.accountId, e.title, e.subtitle, e.primaryColor, e.baseUrl, e.greeting, e.newMessagePlaceholder, e.emailInputPlaceholder, e.newMessagesNotificationText, e.requireEmailUpfront, e.showAgentAvailability, e.agentAvailableText, e.agentUnavailableText];
    [n, r, o, i, a, s, c, u, l, d, g, f, p].some(function (e, t) {
      return e !== h[t];
    }) && this.handleConfigUpdated({
      accountId: n,
      title: r,
      subtitle: o,
      primaryColor: i,
      baseUrl: a,
      greeting: s,
      newMessagePlaceholder: c,
      emailInputPlaceholder: u,
      newMessagesNotificationText: l,
      agentAvailableText: f,
      agentUnavailableText: p,
      requireEmailUpfront: d ? 1 : 0,
      showAgentAvailability: g ? 1 : 0
    });
  }, o.render = function () {
    var t = this.state,
        n = t.isOpen,
        o = t.isLoaded,
        i = t.query,
        a = t.config,
        s = t.shouldDisplayNotifications,
        l = t.isTransitioning,
        d = this.props,
        g = d.customIconUrl,
        f = d.hideOutsideWorkingHours,
        p = d.children,
        h = a.primaryColor;
    if (!i) return null;
    if (void 0 !== f && f && a.isOutsideWorkingHours) return null;
    var m,
        v,
        y,
        b = this.getIframeUrl(),
        S = (n || s) && !l,
        C = {
      useBodyStyles: !1,
      space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
      fonts: {
        body: '-apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",sans-serif;',
        heading: '-apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",sans-serif;',
        monospace: '"Roboto Mono", monospace'
      },
      fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 96],
      fontWeights: {
        body: 400,
        heading: 600,
        bold: 600
      },
      lineHeights: {
        body: 1.5,
        heading: 1.125
      },
      colors: {
        text: "#141414",
        background: "#fff",
        primary: (y = {
          primary: (v = c(void 0 === (m = h) ? "#1890ff" : m)).toString(),
          light: v.lighten().toString(),
          dark: v.darken().toString()
        }).primary,
        secondary: "#722ed1",
        muted: "#f0f0f0",
        gray: "rgba(0, 0, 0, 0.45)",
        input: "rgba(0, 0, 0, 0.65)",
        offset: "rgba(255, 255, 255, 0.8)"
      },
      text: {
        default: {
          color: "text",
          fontSize: 1
        },
        caps: {
          textTransform: "uppercase",
          letterSpacing: "0.2em"
        },
        heading: {
          fontFamily: "heading",
          fontWeight: "heading",
          lineHeight: "heading"
        }
      },
      buttons: {
        primary: {
          cursor: "pointer",
          outline: 0,
          boxShadow: "rgba(0, 0, 0, 0.08) 0 2px 4px",
          transition: "0.2s",
          "&:hover": {
            background: y.light,
            borderColor: y.light,
            boxShadow: "rgba(0, 0, 0, 0.12) 0px 2px 8px"
          },
          "&:active": {
            background: y.dark,
            borderColor: y.dark
          }
        }
      },
      styles: u({
        root: {
          fontFamily: "body",
          lineHeight: "body",
          fontWeight: "body",
          fontSize: 1
        },
        h1: {
          color: "text",
          fontFamily: "heading",
          lineHeight: "heading",
          fontWeight: "heading",
          fontSize: 5
        },
        h2: {
          color: "text",
          fontFamily: "heading",
          lineHeight: "heading",
          fontWeight: "heading",
          fontSize: 4
        },
        h3: {
          color: "text",
          fontFamily: "heading",
          lineHeight: "heading",
          fontWeight: "heading",
          fontSize: 3
        },
        h4: {
          color: "text",
          fontFamily: "heading",
          lineHeight: "heading",
          fontWeight: "heading",
          fontSize: 2
        },
        h5: {
          color: "text",
          fontFamily: "heading",
          lineHeight: "heading",
          fontWeight: "heading",
          fontSize: 1
        },
        h6: {
          color: "text",
          fontFamily: "heading",
          lineHeight: "heading",
          fontWeight: "heading",
          fontSize: 0
        },
        p: {
          color: "text",
          fontFamily: "body",
          fontWeight: "body",
          lineHeight: "body"
        },
        a: {
          color: "primary"
        },
        pre: {
          fontFamily: "monospace",
          overflowX: "auto",
          code: {
            color: "inherit"
          }
        },
        code: {
          fontFamily: "monospace",
          fontSize: "inherit"
        },
        table: {
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0
        },
        th: {
          textAlign: "left",
          borderBottomStyle: "solid"
        },
        td: {
          textAlign: "left",
          borderBottomStyle: "solid"
        },
        img: {
          maxWidth: "100%"
        },
        textarea: {
          transparent: {
            border: "none",
            boxShadow: "none",
            resize: "none",
            outline: 0,
            "&:hover": {
              border: "none",
              boxShadow: "none",
              resize: "none",
              outline: 0
            },
            "&:active": {
              border: "none",
              boxShadow: "none",
              resize: "none",
              outline: 0
            },
            "&:focus": {
              border: "none",
              boxShadow: "none",
              resize: "none",
              outline: 0
            }
          }
        }
      }, w)
    },
        I = ["allow-scripts", "allow-popups", "allow-same-origin", "allow-forms"].join(" ");
    return e(r, {
      theme: C
    }, p({
      sandbox: I,
      isLoaded: o,
      isActive: S,
      isOpen: n,
      isTransitioning: l,
      customIconUrl: g,
      iframeUrl: b,
      query: i,
      shouldDisplayNotifications: s,
      setIframeRef: this.setIframeRef,
      onToggleOpen: this.handleToggleOpen
    }));
  }, n;
}(o.Component),
    M = function (e) {
  function t() {
    var t;
    return (t = e.apply(this, arguments) || this).state = {
      error: null
    }, t;
  }

  l(t, e), t.getDerivedStateFromError = function (e) {
    return {
      error: e
    };
  };
  var n = t.prototype;
  return n.componentDidCatch = function (e, t) {
    console.error("Error rendering Idengagerchat chat:", e, t);
  }, n.render = function () {
    return this.state.error ? null : this.props.children;
  }, t;
}(o.Component),
    T = function T(t) {
  return e(M, null, e(E, Object.assign({}, t, {
    canToggle: !0
  }), function (n) {
    var r = n.sandbox,
        a = n.isLoaded,
        s = n.isActive,
        c = n.isOpen,
        l = n.isTransitioning,
        d = n.customIconUrl,
        g = n.iframeUrl,
        f = n.query,
        p = n.shouldDisplayNotifications,
        h = n.setIframeRef,
        m = n.onToggleOpen,
        v = t.hideToggleButton,
        b = t.iconVariant,
        w = t.renderToggleButton,
        S = t.position,
        C = t.styles,
        I = function (e, t) {
      void 0 === e && (e = {});
      var n = e.chatContainer,
          r = void 0 === n ? {} : n,
          o = e.toggleContainer,
          i = void 0 === o ? {} : o,
          a = e.toggleButton,
          s = void 0 === a ? {} : a,
          c = t.side,
          l = t.offset,
          d = void 0 === l ? 20 : l;

      switch (void 0 === c ? "right" : c) {
        case "left":
          return {
            chatContainer: u({
              left: d,
              right: "auto"
            }, r),
            toggleContainer: u({
              left: d,
              right: "auto"
            }, i),
            toggleButton: s
          };

        case "right":
        default:
          return {
            chatContainer: u({
              right: d,
              left: "auto"
            }, r),
            toggleContainer: u({
              right: d,
              left: "auto"
            }, i),
            toggleButton: s
          };
      }
    }(void 0 === C ? {} : C, function (e) {
      if (!e) return {
        side: "right",
        offset: 20
      };

      switch (e) {
        case "left":
          return {
            side: "left",
            offset: 20
          };

        case "right":
          return {
            side: "right",
            offset: 20
          };

        default:
          return e;
      }
    }(void 0 === S ? "right" : S)),
        x = I.chatContainer,
        O = I.toggleContainer,
        _ = void 0 === O ? {} : O,
        E = I.toggleButton,
        M = void 0 === E ? {} : E;

    return e(o.Fragment, null, e(i.iframe, {
      ref: h,
      title: "Idengagerchat Chat Widget Container",
      className: "Idengagerchat-chatWindowContainer",
      sandbox: r,
      animate: s ? "open" : "closed",
      initial: "closed",
      variants: {
        closed: {
          opacity: 0,
          y: 4
        },
        open: {
          opacity: 1,
          y: 0
        }
      },
      transition: {
        duration: .2,
        ease: "easeIn"
      },
      src: g + "?" + f,
      style: s ? void 0 === x ? {} : x : {
        pointerEvents: "none",
        height: 0,
        minHeight: 0
      },
      sx: {
        border: "none",
        bg: "background",
        variant: !c && p ? "styles.WidgetContainer.notifications" : "styles.WidgetContainer"
      }
    }, "Loading..."), a && !v && e(i.div, {
      className: "Idengagerchat-toggleButtonContainer",
      initial: !1,
      style: _,
      animate: c ? "open" : "closed",
      sx: {
        variant: "styles.WidgetToggleContainer"
      }
    }, w && "function" == typeof w ? w({
      isOpen: c,
      onToggleOpen: m,
      isDisabled: l
    }) : e(y, {
      style: M,
      isDisabled: l,
      isOpen: c,
      customIconUrl: d,
      iconVariant: b,
      toggle: m
    })));
  }));
},
    P = function P(t) {
  return e(M, null, e(E, Object.assign({}, t, {
    canToggle: !1
  }), function (t) {
    var n = t.isLoaded;
    return e(i.iframe, {
      ref: t.setIframeRef,
      className: "Idengagerchat-chatWindowContainer",
      sandbox: t.sandbox,
      animate: n ? "open" : "closed",
      initial: "closed",
      variants: {
        closed: {
          opacity: 0
        },
        open: {
          opacity: 1
        }
      },
      transition: {
        duration: .2,
        ease: "easeIn"
      },
      src: t.iframeUrl + "?" + t.query,
      sx: {
        opacity: n ? 1 : 0,
        border: "none",
        bg: "background",
        variant: "styles.ChatWindowContainer"
      }
    }, "Loading...");
  }));
},
    U = function U() {
  return window.dispatchEvent(new Event("idengagerchat:open"));
},
    B = function B() {
  return window.dispatchEvent(new Event("idengagerchat:close"));
},
    A = function A() {
  return window.dispatchEvent(new Event("idengagerchat:toggle"));
},
    k = function k() {
  console.warn("`Idengagerchat.identify` has not been implemented yet!");
},
    D = {
  open: U,
  close: B,
  toggle: A
};

export default T;
export { T as ChatWidget, P as ChatWindow, D as Idengagerchat, B as close, k as identify, U as open, A as toggle };